import React from "react";

export default function Approvements() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.2833 11.9998H18.9996L17.3328 10.333L15.666 8.66626V11.3823C15.666 11.7527 15.9129 11.9998 16.2833 11.9998Z"
                fill="#4F6E90"/>
            <path
                d="M15.8746 13.2218C14.812 13.2218 13.9995 12.3913 13.9995 11.3051V8.1106H10.8742C9.81166 8.1106 8.99902 8.94117 8.99902 10.0274V18.9725C8.99902 20.0587 9.81155 20.8892 10.8742 20.8892H17.1246C18.1872 20.8892 18.9997 20.0587 18.9997 18.9725V13.2221L15.8746 13.2218ZM16.3121 15.5859L13.812 18.1416C13.562 18.3971 13.187 18.3971 12.9369 18.1416L11.6867 16.8637C11.4368 16.6082 11.4368 16.2248 11.6867 15.9692C11.9367 15.7137 12.3118 15.7137 12.5619 15.9692L13.3744 16.7998L15.437 14.6913C15.687 14.4358 16.062 14.4358 16.3121 14.6913C16.5622 14.9469 16.5622 15.3303 16.3121 15.5859Z"
                fill="#354F6C"/>
        </svg>
    );
}
